import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze látek — zrcadlo Tabidoo tabulky „databazelatek". */
export function DatabazeLatekPage() {
  return (
    <TabidooTablePage
      table="latky"
      storagePrefix="latky"
      title="Databáze látek"
      subtitle="Hledej globálně, filtruj po sloupcích, přehazuj sloupce tažením. Klikni na řádek pro detail a editaci — nebo z něj udělej kopii."
      createLabel="Nová látka"
    />
  );
}
